import { FC } from 'react'

import { observer } from 'mobx-react'

import PanesHeader from 'modules/core/components/PanesHeader'

import type Field from 'modules/custom_resources/store/models/customResources/Field'
import type Resource from 'modules/custom_resources/store/models/customResources/Resource'
import type Schema from 'modules/custom_resources/store/models/customResources/Schema'
import type Value from 'modules/custom_resources/store/models/customResources/Value'

import Table from './_Table'

interface Props {
  schema: Schema
  fields: Field[]
  resource?: Resource
  values?: Value[]
  attachableId: number
  attachableType: string
  canManage: boolean
  canAddValues: boolean
}

const CustomTableComponent: FC<Props> = ({
  schema,
  fields,
  values,
  attachableId,
  canManage,
  canAddValues,
}) => {
  return (
    <>
      <PanesHeader title={schema.attributes.label} />
      <Table
        attachableId={attachableId}
        fields={fields}
        schema={schema}
        values={values}
        canManage={canManage}
        canAddValues={canAddValues}
      />
    </>
  )
}

export default observer(CustomTableComponent)
